import { apiClient } from '../../../../../../api';
import { ValidateAndUploadView } from '../../../../../../components/validate-upload-view/ValidateAndUploadView';
import { PntSchedulesPreview } from './PntSchedulesPreview';
import { Station } from '@app/core/types/stations';

export function PntSchedulesCsvUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadView
      allowedExtensions={['.csv']}
      validateFn={(file: File) =>
        apiClient.audit.pntSchedulesCsvValidate({
          stationId: station.id,
          file,
        })
      }
      importFn={(file: File) =>
        apiClient.audit.pntSchedulesCsvImport({
          stationId: station.id,
          file,
        })
      }
      renderPreview={(data) => <PntSchedulesPreview data={data} />}
    />
  );
}
